import React, { useState } from 'react';
import Button from '../Button';

const DateInput = ({ onAddDate }) => {
  const [selectedDate, setSelectedDate] = useState('');

  const handleChange = (event) => {
    setSelectedDate(event.target.value);
  };

  const handleAddDate = () => {
    if (selectedDate) {
      onAddDate(selectedDate);
      setSelectedDate('');
    }
  };

  return (
    <div className="date-input flex flex-col gap-10">
      
      <input
        type="date"
        value={selectedDate}
        onChange={handleChange}
      />
      <Button style={{width: '82px'}} onClick={handleAddDate}>Add</Button>
    </div>
  );
};

export default DateInput;
